export default __webpack_public_path__ + "static/media/clothingStand.5ffb75d7.png";